import API from "../../../api/axiosClient";

const baseUrl = "GroupMember";

export const getMembers = async (groupId: string) => {
    const response = await API.get(
        `${baseUrl}/group/${groupId}`
    );

    return response.data;
};

export const addCoordinator = async (data: any) => {
    await API.post(
        `${baseUrl}/coordinator`,
        data
    );
};

export const changeRole = async (
    groupMemberId: string,
    data: any
) => {
    await API.put(
        `${baseUrl}/${groupMemberId}/role`,
        data
    );
};
export const joinGroup = async (
    groupId: string
) => {
    const response = await API.post(
        `${baseUrl}/join/${groupId}`
    );

    return response.data;
};
export const blockMember = async (
    groupMemberId: string,
    data: any
) => {
    await API.put(
        `${baseUrl}/${groupMemberId}/block`,
        data
    );
};

export const muteMember = async (
    groupMemberId: string,
    data: any
) => {
    await API.put(
        `${baseUrl}/${groupMemberId}/mute`,
        data
    );
};

export const removeMember = async (
    groupMemberId: string
) => {
    await API.delete(
        `${baseUrl}/${groupMemberId}`
    );
};

export const getMyGroupStatus = async (
    groupId: string
) => {
    const response = await API.get(
        `${baseUrl}/group/${groupId}/mystatus`
    );

    return response.data;
};

export const leaveGroup = async (
    groupId: string
) => {
    await API.delete(
        `${baseUrl}/group/${groupId}/leave`
    );
};

  